export function SelectedReasonSection() {
  const reasons = [
    {
      icon: 'ri-school-line',
      title: '学校別のテスト対策',
      description: '各中学校の出題傾向を熟知。過去問分析で高得点を狙います。'
    },
    {
      icon: 'ri-file-check-line',
      title: '提出物まで管理',
      description: 'ワークの進捗を毎回確認。提出忘れをなくし、内申点を守ります。'
    },
    {
      icon: 'ri-book-open-line',
      title: '苦手単元の復習',
      description: '数学や英語では、つまずいた単元は前の学年まで戻って復習。基礎から固めます。'
    },
    {
      icon: 'ri-lightbulb-line',
      title: '勉強のやり方から指導',
      description: 'ノートの取り方、暗記法、復習のタイミングなど、学習方法を伝授。'
    },
    {
      icon: 'ri-door-open-line',
      title: '自習室完備',
      description: '授業がない日も自習室を利用可能。集中できる環境を提供します。'
    },
    {
      icon: 'ri-parent-line',
      title: '保護者への定期報告',
      description: '月1回の学習報告書で進捗を共有。面談も随時実施します。'
    },
    {
      icon: 'ri-calendar-line',
      title: '学習計画表の作成',
      description: 'テスト2週間前から逆算した計画表を作成。無理なく進められます。'
    }
  ];

  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-black text-gray-800 mb-4">
            選ばれる7つの理由
          </h2>
          <p className="text-sm md:text-base text-gray-600">
            廿日市市で中学生の学習塾をお探しなら、当塾にお任せください
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-blue-50 to-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all border border-blue-100"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-blue-600 rounded-lg mb-4">
                <i className={`${reason.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2">
                {reason.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-base md:text-lg text-gray-700 leading-relaxed">
            <strong>個別指導</strong>だから、一人ひとりの<br />
            ペースに合わせた指導が可能。<br />
            <strong>苦手克服</strong>から<strong>成績アップ</strong>まで、<br />
            しっかりサポートします。
          </p>
        </div>
      </div>
    </section>
  );
}
